import { render, staticRenderFns } from "./RmpTextBtn.vue?vue&type=template&id=212644da"
import script from "./RmpTextBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpTextBtn.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpTextBtn.vue?vue&type=style&index=0&id=212644da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports